export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0x0000000000000000000000000000000000000000",
  edgeFactory: "0x0000000000000000000000000000000000000000",
  edgeFactoryPerspective: "0x0000000000000000000000000000000000000000",
  escrowedCollateralPerspective: "0xD4101919FC8AEdF2f037140E97442Ee5e34707e9",
  eulerEarnFactoryPerspective: "0x0000000000000000000000000000000000000000",
  eulerEarnGovernedPerspective: "0x0000000000000000000000000000000000000000",
  eulerUngoverned0xPerspective: "0x29D739716F64E84E81552ffDDc36547A39282bCa",
  eulerUngovernedNzxPerspective: "0x4e8b46c877bC12555405FdcB37983520a2f6323D",
  evkFactoryPerspective: "0x09867085527984d5b74d6C0796f4D600198b7b6E",
  externalVaultRegistry: "0x8fCBcee73379d03C2978117B7Ef2Da139b698EA2",
  feeFlowController: "0xfD97C35d07229dEd53b0267d182EFeD3E8971233",
  feeFlowControllerUtil: "0x0000000000000000000000000000000000000000",
  governedPerspective: "0xA2c071deC6F06686174094285FBA0a8EA4269fDD",
  irmRegistry: "0xb021862dfDd56d9410933B5274F287f81efADDc1",
  kinkIRMFactory: "0xA120aa1910597824108035e50807f60e8536F2b5",
  oracleAdapterRegistry: "0xe6b40CACCe2e3951974c678D2B6CE0f561A0aDE9",
  oracleRouterFactory: "0x6e8D443c6417E849da5602F6eD38Fa5666792DDc",
  swapVerifier: "0x0000000000000000000000000000000000000000",
  swapper: "0x0000000000000000000000000000000000000000",
  termsOfUseSigner: "0x9fcFb87F4463A5ecFa6709f1673e2B888716a604",
} as const
